
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";
import UrlRedirectHandler from "./components/UrlRedirectHandler";

// Lazy load pages to reduce initial bundle size
const Index = lazy(() => import("./pages/Index"));
const CharacterPage = lazy(() => import("./pages/CharacterPage"));
const ObjectPage = lazy(() => import("./pages/ObjectPage"));
const AdPage = lazy(() => import("./pages/AdPage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const DayNumberPage = lazy(() => import("./pages/DayNumberPage"));
const WeekdayPage = lazy(() => import("./pages/WeekdayPage"));
const SearchResults = lazy(() => import("./pages/SearchResults"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <UrlRedirectHandler>
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center">იტვირთება...</div>}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/:character" element={<CharacterPage />} />
                <Route path="/:character/:objectName" element={<ObjectPage />} />
                <Route path="/თვის-რიცხვები" element={<DayNumberPage />} />
                <Route path="/კვირის-დღეები" element={<WeekdayPage />} />
                <Route path="/რეკლამა" element={<AdPage />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </UrlRedirectHandler>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
